import { css } from 'styled-components';

export const AvailabilityRangeStyles = css`
  .b-grid-header .b-sch-timerange {
    height: 28px;
    &.available-range {
      background: var(--blue-60);
      padding: 0 var(--spacing-02);
    }
    &.unavailable-range {
      background: none;
    }
  }
  .b-timeline-subgrid .b-sch-timerange {
    background: none;
    &.available-range {
      z-index: 16;
      border-right: 2px solid var(--border-color);
      border-left: 2px solid var(--border-color);
    }
    &.unavailable-range {
      background-image: linear-gradient(
        -45deg,
        rgba(256, 256, 256, 0.7) 47%,
        rgba(256, 256, 256, 0.7) 48%,
        var(--coolest-gray-50) 50%,
        rgba(256, 256, 256, 0.7) 52%,
        rgba(256, 256, 256, 0.7) 53%
      );
      background-size: 12px 12px;
      z-index: 4;
    }
  }
  .b-timeline-subgrid .b-sch-resourcetimerange.unavailable-range {
    background: linear-gradient(
      -45deg,
      rgba(256, 256, 256, 0.7) 47%,
      rgba(256, 256, 256, 0.7) 48%,
      var(--coolest-gray-50) 50%,
      rgba(256, 256, 256, 0.7) 52%,
      rgba(256, 256, 256, 0.7) 53%
    );
    background-size: 12px 12px;
    z-index: 16;
  }
`;
